var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",class:{
    'card--item': _vm.item,
    'card--hoverable': _vm.hoverable && !_vm.disabled,
}},[_vm._t("default"),(_vm.disabled)?_c('div',{staticClass:"card--disabled"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }